import React from 'react';
import { PageHero } from '../components/PageHero';
import { Button } from '../components/ui/Button';
import { Mail, MapPin, Calendar, Clock } from 'lucide-react';
import { BOOKING_URL } from '../lib/navigation';
export function GetStarted() {
  return <div className="animate-fade-in-up" data-id="element-229">
      <PageHero title="Get Started" subtitle="Take the first step towards a life that feels like yours." data-id="element-230" />

      <section className="py-20 bg-white" data-id="element-231">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-232">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-233">
            {/* Left Column: Info */}
            <div data-id="element-234">
              <h2 className="text-3xl font-medium text-teal mb-8" data-id="element-235">
                Ready to talk?
              </h2>
              <p className="text-lg text-teal/80 mb-12" data-id="element-236">
                The best way to see if we're a good fit is to hop on a quick
                video call. It's free, low-pressure, and gives you a chance to
                ask any questions you have.
              </p>

              <div className="space-y-8 mb-12" data-id="element-237">
                <div className="flex items-start" data-id="element-238">
                  <div className="w-12 h-12 bg-sage/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-sage" data-id="element-239">
                    <Calendar className="w-6 h-6" data-id="element-240" />
                  </div>
                  <div data-id="element-241">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-242">
                      Free Consultation
                    </h3>
                    <p className="text-teal/70" data-id="element-243">
                      15-minute video call to discuss your needs and goals.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-244">
                  <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-terracotta" data-id="element-245">
                    <Clock className="w-6 h-6" data-id="element-246" />
                  </div>
                  <div data-id="element-247">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-248">
                      Session Availability
                    </h3>
                    <p className="text-teal/70" data-id="element-249">
                      Flexible weekday and evening appointments available.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-250">
                  <div className="w-12 h-12 bg-teal/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-teal" data-id="element-251">
                    <MapPin className="w-6 h-6" data-id="element-252" />
                  </div>
                  <div data-id="element-253">
                    <h3 className="font-medium text-teal text-lg mb-1" data-id="element-254">
                      Location
                    </h3>
                    <p className="text-teal/70" data-id="element-255">
                      Secure online video therapy available across all of
                      Ontario.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-neutral-soft p-8 rounded-2xl border border-sage/20" data-id="element-256">
                <h3 className="font-medium text-teal mb-4" data-id="element-257">Contact</h3>
                <a href="mailto:jess@arrivetherapy.ca" className="flex items-center text-teal/80 hover:text-terracotta transition-colors" data-id="element-258">
                  <Mail className="w-5 h-5 mr-3" data-id="element-259" />
                  jess@arrivetherapy.ca
                </a>
              </div>
            </div>

            {/* Right Column: Simple Booking CTA */}
            <div className="flex items-start" data-id="element-260">
              <div className="bg-white rounded-3xl shadow-xl border border-neutral-100 p-8 md:p-10 w-full text-center" data-id="element-261">
                <div className="w-20 h-20 bg-sage/10 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-262">
                  <Calendar className="w-10 h-10 text-sage" data-id="element-263" />
                </div>

                <h3 className="text-2xl font-medium text-teal mb-4" data-id="element-264">
                  Book Your Session
                </h3>
                <p className="text-teal/70 mb-4 max-w-sm mx-auto" data-id="element-265">
                  Schedule a free 15-minute video consultation to see if we're a
                  good fit. No pressure, no commitment, just a conversation.
                </p>
                <p className="text-teal/70 mb-8 text-sm max-w-sm mx-auto" data-id="element-266">
                  Already know you're ready? You can also go ahead and book your
                  first full session directly.
                </p>

                <Button className="w-full" size="lg" onClick={() => window.open(BOOKING_URL, '_blank')} data-id="element-267">
                  Book Now
                </Button>

                <div className="mt-8 pt-6 border-t border-neutral-100" data-id="element-268">
                  <p className="text-sm text-teal/60" data-id="element-269">
                    Have questions or need help booking? Email me at{' '}
                    <a href="mailto:jess@arrivetherapy.ca" className="text-terracotta hover:underline" data-id="element-270">
                      jess@arrivetherapy.ca
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
}